/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1PersonIdAddresses202,
  PostApiV1PersonIdAddresses400,
  PostApiV1PersonIdAddresses401,
  PostApiV1PersonIdAddresses404,
  PostApiV1PersonIdAddresses409,
  PostApiV1PersonIdAddresses500,
  PostApiV1PersonIdAddressesMutationRequest,
  PostApiV1PersonIdAddressesMutationResponse,
  PostApiV1PersonIdAddressesPathParams,
} from "../../types/personRegisterController/PostApiV1PersonIdAddresses.ts";
import { createPersonAddressRequestSchema } from "../createPersonAddressRequestSchema.ts";
import { personAddressDetailViewModelSchema } from "../personAddressDetailViewModelSchema.ts";

export const postApiV1PersonIdAddressesPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<PostApiV1PersonIdAddressesPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1PersonIdAddresses202Schema = z.lazy(
  () => personAddressDetailViewModelSchema,
) as unknown as ToZod<PostApiV1PersonIdAddresses202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1PersonIdAddresses400Schema =
  z.any() as unknown as ToZod<PostApiV1PersonIdAddresses400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1PersonIdAddresses401Schema =
  z.any() as unknown as ToZod<PostApiV1PersonIdAddresses401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1PersonIdAddresses404Schema =
  z.any() as unknown as ToZod<PostApiV1PersonIdAddresses404>;

/**
 * @description (Conflict) Há um conflito com os dados existentes.
 */
export const postApiV1PersonIdAddresses409Schema =
  z.any() as unknown as ToZod<PostApiV1PersonIdAddresses409>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1PersonIdAddresses500Schema =
  z.any() as unknown as ToZod<PostApiV1PersonIdAddresses500>;

export const postApiV1PersonIdAddressesMutationRequestSchema = z.lazy(
  () => createPersonAddressRequestSchema,
) as unknown as ToZod<PostApiV1PersonIdAddressesMutationRequest>;

export const postApiV1PersonIdAddressesMutationResponseSchema = z.lazy(
  () => postApiV1PersonIdAddresses202Schema,
) as unknown as ToZod<PostApiV1PersonIdAddressesMutationResponse>;
